// Legacy serialization includes non camelcase properties
/* eslint-disable camelcase */
import Immutable from 'immutable'
import moment from 'moment'

import createRelationship from './Relationship'

export const ClientRecord = Immutable.Record({
  abn: null,
  authorisedUsersForPartners: Immutable.Map(),
  authorisedPartners: Immutable.Set(), // Partner Ids
  billing_groups: Immutable.Set(), // BillingGroup ids
  date_added: null,
  date_updated: null,
  id: null,
  ipns: Immutable.Set(),
  name: null,
  overdue: null,
  partner: null, // Partner id,
  payment_tokens: Immutable.Set(), // Token uuids
  relationships: Immutable.OrderedSet(),
  signups: Immutable.Set(), // Signup Ids
  sites: Immutable.Set(),
}, 'Client')

export default function createClient({
  authorisedPartners = [],
  authorisedUsersForPartners = {},
  billing_groups = [],
  date_added,
  date_updated,
  ipns = [],
  partner,
  payment_tokens = [],
  relationships = [],
  signups = [],
  sites = [],
  ...data
}) {
  const sortedRelationships = Immutable.Set(relationships)
    .sortBy(r => r.user.first_name + ' ' + r.user.last_name)
    .map(r => createRelationship({
      client_id: data.id,
      ...r,
    }))
  const filteredPartners = authorisedPartners.filter(p => p)

  return new ClientRecord({
    // TODO: Authorized Partners are not finalised
    authorisedPartners: Immutable.Set(filteredPartners),
    authorisedUsersForPartners: Immutable.Map(authorisedUsersForPartners),
    billing_groups: Immutable.Set(billing_groups.map(bg => bg.id)),
    date_added: date_added ? moment(date_added) : null,
    date_updated: date_added ? moment(date_updated) : null,
    ipns: Immutable.Set(ipns),
    partner: partner ? partner.id : null,
    payment_tokens: Immutable.Set(payment_tokens.map(pt => pt.uuid)),
    relationships: sortedRelationships,
    signups: Immutable.Set(signups.map(s => s.id)),
    sites: Immutable.Set(sites.map(s => s.id)),
    ...data,
  })
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Client.js